import { Modal, Checkbox, Divider, Col, Row } from "antd";
import i18next from "i18next";
import { useState } from "react";
import { EdrService } from "../../service/cartoService";

const ModalDelete = ({ open, action, fotos, setFotos }) => {

  //Este estado almacena el nombre de las fotos que se seleccionan y las cuales se quiere eliminar.
  const [selectedFotos, setSelectedFotos] = useState([]);

  //Una variable boolean que si es true se seleccionan todos los checkboxes
  let selectAll = fotos.length === selectedFotos.length;

  //Una variable boolean que si es true muestra un cuadro azul en la checkbox de "Seleccionar todos"
  const indeterminate = selectedFotos.length > 0 && selectedFotos.length < fotos.length;

  /**
   * Esta función añade al estado selectedFotos los nombres de las fotos cuando se selecciona su checkbox.
   * 
   * @param {*} checkedValues 
   */
  const onChange = (checkedValues) => {
    //console.log('fotos', checkedValues)
    setSelectedFotos(checkedValues);
  };

  /**
   * Esta función selecciona o deselecciona todas las casillas checkbox.
   * 
   * @param {*} e 
   */
  const onSelectAllChange = (e) => {
    setSelectedFotos(e.target.checked ? fotos : []);
  };

  /**
   * Esta función realiza la petición DELETE y elimina los nombres de las fotos del array que se renderiza
   * para mostrar las fotos en la app.
   */
  const removePhotos = async () => {
    //console.log('fotos', selectedFotos);
    let copyFotos = [...fotos]
    for await (let foto of selectedFotos) {
      EdrService.removeEdarFoto(foto)
      const index = copyFotos.indexOf(foto);
      copyFotos.splice(index, 1);
    }
    console.log('fotos', copyFotos)
    setFotos(copyFotos)
  }


  return (
    <Modal
      title={i18next.t('common.tools.edit.delete-img')} style={{ float: "right", marginRight: "4%" }}
      open={open}
      onOk={() => { action(false); setSelectedFotos([]); selectAll = false; removePhotos() }}
      onCancel={() => { action(false); setSelectedFotos([]); selectAll = false }}
    >
      {
        <>
          <Checkbox indeterminate={indeterminate} onChange={onSelectAllChange} checked={selectAll}>
            {i18next.t('common.select_all')}
          </Checkbox>
          <Divider />

          <Checkbox.Group value={selectedFotos} style={{ width: '100%' }} onChange={onChange}>
            <Row>
              {
                
                fotos.map((foto, i) => (
                  <Col span={24/fotos.length} key={foto}>
                    <Checkbox value={foto}>{"Foto "+(i+1)}</Checkbox>
                  </Col>
                ))
              }
            </Row>
          </Checkbox.Group>
        </>
      }
    </Modal>
  );
}

export default ModalDelete;